<template>
  <span class="child-thumbnail">
    <span v-if="type === 'select'">
      <div
          v-if="imageUrl"
          :class="getSelectedClass(selected)"
          class="thumbnail"
          :style="{background: 'url(' + imageUrl + ')'}"
      >
      </div>
      <div
          v-else
          :class="getSelectedClass(selected)"
          class="thumbnail d-flex justify-content-center align-items-center"
          style="background-color: white;"
      >
          <icon name="child" style="color: #bcc6d3;"></icon>
      </div>
    </span>
    <span v-else-if="type === 'show-simple'">
      <div
          v-if="imageUrl"
          :class="getSelectedClass(selected)"
          class="thumbnail"
          :style="{height: height, width: height, borderWidth: '1px', background: 'url(' + imageUrl + ')'}"
      >
      </div>
      <div
          v-else
          :class="getSelectedClass(selected)"
          class="thumbnail d-flex justify-content-center align-items-center"
          :style="{height: height, width: height, borderWidth: '1px'}"
          style="background-color: white;"
      >
          <icon name="child" style="color: #bcc6d3;"></icon>
      </div>
    </span>
    <span
        v-else
        class="d-flex flex-column align-items-center"
    >
      <span v-on:click="emitClick()">
        <div
            v-if="imageUrl"
            :class="getPresenceClass(child.presence)"
            class="thumbnail"
            :style="{background: 'url(' + imageUrl + ')'}"
        >
        </div>
        <div
            v-else
            :class="getPresenceClass(child.presence)"
            class="thumbnail d-flex justify-content-center align-items-center"
            style="background-color: white;"
        >
            <icon name="child" style="color: #bcc6d3;"></icon>
        </div>
      </span>
      <span v-if="hideStatusBox === true ">
      </span>
      <span v-else>
        <span v-if="child.status && ((child.status.instruction && (child.status.instruction === 'high' || child.status.instruction === 'normal')) ||child.status.ill === true || child.status.sleep === true || (child.photo_allowed_setting == 1 && child.photo_allowed != 1)) ">
          <router-link v-if="getChild(child.id)" :to="isAuthorized('instructions', 'index', 'view') ? '/care' : ''">
            <span v-on:click="selectChild(child)">
              <span class="status-box my-1 p-1 default">
                <icon
                  v-if="child.status.instruction === 'high'"
                  class="status"
                  name="care-prio-high"
                  fontSize="1rem"
                ></icon>
                <icon
                    v-else-if="child.status.instruction === 'normal'"
                    class="status"
                    name="care-prio-normal-solid"
                    fontSize="1rem"
                ></icon>
                <icon
                  v-if="child.photo_allowed_setting == 1 && child.photo_allowed != 1"
                  class="status"
                  name="photos-none-solid"
                  fontSize="1rem"
                ></icon>
                <span
                  v-if="child.status.ill === true"
                  class="status"
                >
                  <i class="fa-solid fa-temperature-three-quarters"></i>
                </span>
                <span
                  v-if="child.status.sleep === true"
                  class="status"
                >
                  <i class="fa-solid fa-moon-stars"></i>
                </span>
              </span>
            </span>
          </router-link>
        </span>
        <span v-else>
          <span class="status-box my-1 p-1 muted"></span>
        </span>
      </span>
    </span>
  </span>
</template>

<script>
import Icon from '@/components/Icon'
export default {
  name: 'child-thumbnail',
  props: [
    'child',
    'type',
    'selected',
    'height',
    'childReset',
    'hideStatusBox'
  ],
  components: {
    Icon
  },
  data () {
    return {
      idChild: null,
      photo: null,
      imageUrl: null,
    }
  },
  mounted() {
    this.getImageToken()
    if (this.$store.getters.imageToken !== null && this.$store.getters.imageToken !== 'loading') {
      this.imageUrl = this.buildImageUrl(this.$store.getters.imageToken)
    }
  },
  watch: {
    '$store.getters.imageToken': function(newValue) {
      if (newValue !== null && newValue !== 'loading') {
        this.imageUrl = this.buildImageUrl(newValue)
      }
    },
    'child.photo_updated_at'() {
      if (this.$store.getters.imageToken !== null && this.$store.getters.imageToken !== 'loading') {
        this.imageUrl = this.buildImageUrl(this.$store.getters.imageToken)
      }
    },
    childReset() {
      if (this.$store.getters.imageToken !== null && this.$store.getters.imageToken !== 'loading') {
        this.imageUrl = null
        this.imageUrl = process.env.VUE_APP_API_V3_URL + '/children/' + this.child.id + '/thumbnail?token=' + this.$store.getters.imageToken + '&reset=' + (new Date).getTime()
      }
    },
  },
  methods: {
    buildImageUrl (token) {
      let url = process.env.VUE_APP_API_V3_URL + '/children/' + this.child.id + '/thumbnail?token=' + token
      if (this.child.photo_updated_at) {
        url += '&v=' + encodeURIComponent(this.child.photo_updated_at)
      }
      return url
    },
    getSelectedClass (selected) {
      if (selected === true) {
        return 'selected'
      } else {
        return 'not-selected'
      }
    },
    getPresenceClass () {
      let presenceClass = ''
      if (this.getChildIsPresent(this.child) === true) {
        presenceClass ='present'
      } else {
        presenceClass = 'not-present'
      }
      if (this.hideStatusBox) {
        presenceClass += ' thumbnail-small';
      }
      return presenceClass
    },
    emitClick () {
      this.$emit('clickHandler', this.child)
    },
    selectChild (child) {
      if (child.id_child) {
        child.id = child.id_child
      }
      if (child.id) {
        child.id_child = child.id
      }
      this.$store.commit('SET_SELECTED_CHILD', child)
    }
  }
}
</script>

<style scoped>
img {
  width: 100%;
  margin: 0;
  margin-top: 2px;
}
.present {
  border: 3px solid #48C88D;
}
.not-present {
  border: 3px solid #FF594F;
}
.selected {
  border: 3px solid #6ac8f2;
}
.not-selected {
  border: 3px solid #dedee7;
}
.child-thumbnail {
  position: relative;
  top: 0;
  left: 0;
}
.thumbnail {
  position: relative;
  top: 0;
  left: 0;
  width: 66px;
  height: 66px;
  border-radius: 50%;
  background-repeat: no-repeat !important;
  background-attachment: fixed;
  background-position: center;
  background-size: cover !important;
}
.thumbnail-small {
  width: 50px;
  height: 50px;
}

.btn-status {
    color: #fff;
    background-color: rgb(188, 198, 211);
    border: none;
}

.status-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    height: 30px;
    min-width: 75px;
    border-radius: 5px;
    background-color: rgb(188, 198, 211);

    & > span {
        display: flex;
        align-items: center;
    }
}
.status-box.muted {
  opacity: 0.0;
}
.no-status-block {
  display: block;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.status {
    color: #fff;
    padding: 1px;
}

img.status {
  width: 20px;
}
</style>
